export const SET_POPUP = 'SET_POPUP';

export function setPopup(key = 'default', open = false) {
  return { type: SET_POPUP, key, open };
}
